export default "/_next/static/images/adffa0861dd9c6f64ff10b09234d827c.png";